/**
 * Created by piotr.pozniak@thebeaverhead.com on 28/07/2022
 */

import React, { useCallback, useEffect } from "react";
import classNames from "classnames";
import { Store as NotificationComponent } from "react-notifications-component";

/**
 *
 * @param id
 * @param children
 * @param onClose
 * @param type
 * @returns {React.JSX.Element}
 * @constructor
 */
const NotificationPopup = ({ id, children, onClose, type = "danger" }) => {
  useEffect(() => {
    return () => {
      NotificationComponent.removeNotification(id);
    };
  }, []);

  /**
   *
   * @type {(function(): void)|*}
   */
  const _onClose = useCallback(() => {
    if (typeof onClose === "function") {
      onClose();
    }
    NotificationComponent.removeNotification(id);
  }, []);

  return (
    <div
      className={classNames(
        `notification-${type}`,
        "n-child",
        "alert",
        `alert-${type}`
      )}
    >
      <button
        type="button"
        className="close"
        data-dismiss="modal"
        onClick={_onClose}
      >
        &times;
      </button>
      {children}
    </div>
  );
};

export default NotificationPopup;
